const THEME_NAME = "impulse";

const gtcUpdateAndOpenCart = (responseJson) => {
    switch (THEME_NAME) {
        case 'dawn':
            dawnOpenCart(responseJson);
            break;
        case 'prestige':
        case 'impact':
            prestigeOpenCart(responseJson);
            break;
        case 'impulse':
            impulseOpenCart(responseJson);
            break;
        default:
            console.warn(`Theme ${ THEME_NAME } is not supported.`);
            break;
    }
};

const dispatchCartRefreshEvent = () => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
};

const getCartDrawer = () => {
    switch (THEME_NAME) {
        case 'dawn':
            return document.querySelector('cart-drawer');
        case 'prestige':
        case 'impact':
            return document.querySelector('cart-drawer');
        case 'impulse':
            return document.querySelector('#CartDrawer');
        default:
            console.warn(`Theme ${ THEME_NAME } is not supported.`);
            return null;
    }
}

const prestigeOpenCart = () => {
    dispatchCartRefreshEvent();
    const themeCartDrawer = getCartDrawer();
    if (themeCartDrawer) {
        themeCartDrawer.show();
        requestAnimationFrame(() => {
            themeCartDrawer.focus();
        });
    }
};

const dawnOpenCart = (responseJson) => {
    const themeCartDrawer = document.querySelector('cart-notification') || getCartDrawer();
    if (themeCartDrawer) {
        themeCartDrawer.setActiveElement(gtcPreviousFocus);
        themeCartDrawer.classList.remove("is-empty");
        themeCartDrawer.renderContents(responseJson);
        requestAnimationFrame(() => {
            themeCartDrawer.focus();
        });
    }
};

const impulseOpenCart = () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
    const themeCartDrawer = getCartDrawer();
    if (themeCartDrawer) {
        requestAnimationFrame(() => {
            themeCartDrawer.focus();
        });
    }
};

/************************* Async Content *************************/

const getPageContentHtml = async (pageUrl) => {
    try {
        const response = await fetch(`${ pageUrl }.json`);
        const pageJson = await response.json();
        if (pageUrl.includes('policies/')) {
            return pageJson.policy?.body || '';
        } else {
            return pageJson.page?.body_html || '';
        }
    } catch (error) {
        console.error('Error:', error);
        return '';
    }
};

const getSectionHtml = async (section, canonicalUrl) => {
    try {
        const basePath = canonicalUrl ? new URL(canonicalUrl).pathname : window.location.pathname;
        const url = basePath === '/' ? `/?sections=${ section }` : `${ basePath }/?sections=${ section }`;
        const sectionJson = await (await fetch(url)).json();
        return sectionJson[section] || '';
    } catch (error) {
        console.error('Error:', error);
        return '';
    }
};

const getTemplateHtml = async (templateId) => {
    const template = document.getElementById(templateId);
    return template ? template.innerHTML : '';
};

/************************* Trap Focus *************************/

let gtcPreviousFocus = document.activeElement;

const focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

const isFocusable = (element) => {
    return element.matches(focusableSelectors) && !element.disabled && element.tabIndex >= 0;
};

const gtcSetPreviousFocus = (element) => {
    gtcPreviousFocus = element || document.activeElement;
};

const gtcHandleTrapFocus = (e, element) => {

    const isTabPressed = (e.key === 'Tab' || e.keyCode === 9);
    if (!isTabPressed) return;

    const focusableElements = element.focusableElements;
    const firstFocusableElement = element.firstFocusableElement;
    const lastFocusableElement = element.lastFocusableElement;
    const activeElement = document.activeElement;

    if (e.shiftKey) {
        if (activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
        }
    } else {
        if (activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
        }
    }

    if (!focusableElements.includes(activeElement)) {
        firstFocusableElement.focus();
    }
};

const gtcTrapFocus = (container) => {

    if (Shopify.designMode) {
        return;
    }

    const queryString = focusableSelectors;
    const focusableElementsInDOM = Array.from(container.querySelectorAll(queryString));
    const slotElements = Array.from(container.querySelectorAll('slot'));
    const assignedElements = slotElements.flatMap(slot => slot.assignedElements());
    const focusableElementsInAssignedElements = assignedElements.flatMap(assignedElement => Array.from(assignedElement.querySelectorAll(queryString)));
    const focusableElements = [...focusableElementsInDOM, ...focusableElementsInAssignedElements];

    container.firstFocusableElement = focusableElements[0];
    container.lastFocusableElement = focusableElements[focusableElements.length - 1];
    container.focusableElements = focusableElements;

    if (container.firstFocusableElement) {
        container.firstFocusableElement.focus();
    }

    container.addEventListener('keydown', (e) => gtcHandleTrapFocus(e, container));
};

const gtcRemoveTrapFocus = (element) => {
        element.removeEventListener('keydown', (e) => gtcHandleTrapFocus(e, element));
    if (isFocusable(gtcPreviousFocus)) {
        gtcPreviousFocus.focus();
    } else {
        const focusableElement = gtcPreviousFocus.querySelector(focusableSelectors);
        if (focusableElement) {
            focusableElement.focus();
        } else {
            document.body.focus();
        }
    }
    gtcPreviousFocus = null;
};

/************************* Scrolllock *************************/

let isScrollLocked = false;

const gtcScrollLock = (classArr) => {
    if (isScrollLocked) return;

    isScrollLocked = true;
    const body = document.body;
    const docEl = document.documentElement;
    const scrollbarWidth = window.innerWidth - docEl.clientWidth;
    body.style.paddingRight = `${ scrollbarWidth }px`;
    body.style.overflow = 'hidden';
    if (classArr) {
        body.classList.add(...classArr);
    }
};

const gtcScrollUnlock = (classArr) => {
    if (!isScrollLocked) return;

    isScrollLocked = false;
    const body = document.body;
    body.style.paddingRight = '';
    body.style.overflow = '';
    if (classArr) {
        body.classList.remove(...classArr);
    }
};

/************************* Handleize *************************/

const gtcHandleize = (string) => {
    return string
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-') // replace non-alphanumeric characters with hyphens
        .replace(/^-+|-+$/g, ''); // remove leading and trailing hyphens
};

/************************* Transitions *************************/

const gtcTransitionEnd = (element, callback) => {
    const transitionDuration = parseFloat(getComputedStyle(element).transitionDuration) * 1000; // Convert to milliseconds
    setTimeout(callback, transitionDuration);
};

/************************* Debounce *************************/

const gtcDebounce = (func, delay = 300) => {
    let debounceTimer;
    return function(...args) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func.apply(this, args), delay);
    };
};

/************************* Throttling *************************/

const gtcThrottle = (func, delay = 300) => {
    let lastCall = 0;
    return function(...args) {
        const now = Date.now();
        if (now - lastCall < delay) return;
        lastCall = now;
        return func.apply(this, args);
    };
};

/************************* Set cookie *************************/

const gtcSetCookie = (name, value, days) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${ name }=${ value || "" }${ expires }; path=/`;
};

/************************* Get cookie *************************/

const gtcGetCookie = (name) => {
    const nameEQ = `${ name }=`;
    const ca = document.cookie.split(';');
    for (let c of ca) {
        c = c.trim();
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
};

/************************* Remove cookie *************************/

const gtcRemoveCookie = (name) => {
    document.cookie = `${ name }=; Max-Age=-99999999;`;
}

/************************* Color text on hover *************************/

const gtcChangeColorText = (element) => {
    const dom = {
        currentColorName: element.querySelector('[data-current-color-name]')
    };

    if (!dom.currentColorName && !element.querySelector('[data-color-name]')) {
        console.error('GTCLinkedProductsColorName: Missing [data-current-color-name] element');
        return;
    }

    const settings = {
        currentColorNameText: element.querySelector('[data-color-name].active')?.dataset.colorName
    };

    if (!dom.currentColorName.textContent && settings.currentColorNameText) {
        dom.currentColorName.textContent = settings.currentColorNameText;
    }

    const changeColorName = (event) => {
        const colorNameElem = event.target.closest('[data-color-name]');
        if (colorNameElem) {
            dom.currentColorName.textContent = colorNameElem.dataset.colorName || settings.currentColorNameText;
        }
    };

    const changeBackColorName = () => {
        dom.currentColorName.textContent = settings.currentColorNameText;
    };

    const addEventListeners = () => {
        element.addEventListener('mouseover', changeColorName);
        element.addEventListener('mouseout', changeBackColorName);
        element.addEventListener('focusin', changeColorName);
        element.addEventListener('focusout', changeBackColorName);
    };

    const removeEventListeners = () => {
        element.removeEventListener('mouseover', changeColorName);
        element.removeEventListener('mouseout', changeBackColorName);
        element.removeEventListener('focusin', changeColorName);
        element.removeEventListener('focusout', changeBackColorName);
    };

    addEventListeners();

    return {
        reInit: () => {
            removeEventListeners();
            addEventListeners();
        }
    };
};

/************************* Add product to cart *************************/

/**
 * Adds a product to the cart.
 *
 * @param {Object} options - The options for adding the product to the cart.
 * @param {string} options.variantId - The ID of the product variant to add to the cart.
 * @param {number} [options.quantity=1] - The quantity of the product to add to the cart.
 * @param {Object} [options.properties={}] - Additional properties to include with the product.
 * @param {Function} [options.callBack=null] - A callback function to execute after the product is added to the cart.
 * @returns {Promise<void>} A promise that resolves when the product is added to the cart.
 *
 * @throws Will throw an error if the fetch request fails.
 */
const gtcAddToCart = async ({ products = [], callBack = null }) => {
    if (!Array.isArray(products) || products.length === 0) {
        console.error('Products array is required and cannot be empty');
        return;
    }

    const productData = {
        items: products.map(product => ({
            id: product.variantId,
            quantity: product.quantity || 1,
            properties: product.properties || {},
            selling_plan: product.selling_plan || null
        }))
    };

    if (THEME_NAME === 'dawn') {
        const cartDrawer = document.querySelector('cart-notification') || getCartDrawer();
        if (cartDrawer) {
            productData.sections = cartDrawer.getSectionsToRender().map(section => section.id);
            productData.sections_url = window.location.pathname;
        }
    }

    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(productData)
    };

    const writeError = (error) => {
        const errorText = error.message ? error.message : 'Something went wrong';
        alert(errorText);
    }

    try {
        const response = await fetch('/cart/add.js', config);

        const responseJson = await response.json();
        if (!response.ok) {
            writeError(responseJson);
            throw new Error(responseJson.message);
        }

        gtcUpdateAndOpenCart(responseJson);

        if (callBack) callBack();
    } catch (error) {
        console.error('Error:', error);
    }
};


class gtcVideoAutoplay extends HTMLElement {
    constructor() {
        super();

        this.videoElement = null;
        this.intersectionObserver = null;
    }

    connectedCallback() {
        this.videoElement = this.querySelector('video');
        if (this.videoElement) {
            this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), { threshold: 0 });
            this.intersectionObserver.observe(this.videoElement);
        }
    }

    disconnectedCallback() {
        if (this.intersectionObserver) {
            this.intersectionObserver.unobserve(this.videoElement);
            this.intersectionObserver = null;
        }
    }
    intersectionObserver
    handleIntersection(entries) {
        const isVisible = entries[0].isIntersecting;
        if (isVisible && (this.videoElement.hasAttribute('autoplay') || this.videoElement.played.length > 0)) {
            this.playVideo();
        } else {
            this.pauseVideo();
        }
    }

    playVideo() {
        if (this.videoElement) {

            this.videoElement.play();
            this.classList.add('playing');
            this.classList.remove('paused');
        }
    }

    pauseVideo() {
        if (this.videoElement) {
            this.videoElement.pause();
            this.classList.add('paused');
            this.classList.remove('playing');
        }
    }
}

const gtcOpenOpenerInDesignMode = (element) => {
    if (Shopify.designMode) {
        const section = element.closest('[data-shopify-editor-section]');
        if (section) {
            section.addEventListener('shopify:inspector:activate', (event) => {
                element.open();
            });

            section.addEventListener('shopify:section:load', (event) => {
                element.open();
            });

            section.addEventListener('shopify:section:select', (event) => {
                element.open();
            });

            section.addEventListener('shopify:section:unload', (event) => {
                element.close();
            });

            section.addEventListener('shopify:section:deselect', (event) => {
                element.close();
            });
        }
    }
}



export {
    gtcUpdateAndOpenCart,
    dispatchCartRefreshEvent,
    getCartDrawer,
    prestigeOpenCart,
    dawnOpenCart,
    impulseOpenCart,
    getPageContentHtml,
    getSectionHtml,
    getTemplateHtml,
    gtcSetPreviousFocus,
    gtcTrapFocus,
    gtcRemoveTrapFocus,
    gtcScrollLock,
    gtcScrollUnlock,
    gtcHandleize,
    gtcTransitionEnd,
    gtcDebounce,
    gtcThrottle,
    gtcSetCookie,
    gtcGetCookie,
    gtcRemoveCookie,
    gtcChangeColorText,
    gtcAddToCart,
    gtcVideoAutoplay,
    gtcOpenOpenerInDesignMode
};